import '../assets/NcActionLink-DN3NCDC0.css';
import { A as a } from "../chunks/actionText-jLsEBszD.mjs";
import { n as i } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const r = {
  name: "NcActionLink",
  mixins: [a],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * destionation to link to
     */
    href: {
      type: String,
      default: "#",
      required: !0,
      validator: (e) => {
        try {
          return new URL(e);
        } catch {
          return e.startsWith("#") || e.startsWith("/");
        }
      }
    },
    /**
     * download the link instead of opening
     */
    download: {
      type: String,
      default: null
    },
    /**
     * target to open the link
     */
    target: {
      type: String,
      default: "_self",
      validator: (e) => e && (!e.startsWith("_") || ["_blank", "_self", "_parent", "_top"].indexOf(e) > -1)
    },
    /**
     * Declares a native tooltip when not null
     */
    title: {
      type: String,
      default: null
    },
    /**
     * @deprecated To be removed in @nextcloud/vue 9. Migration guide: remove ariaHidden prop from NcAction* components.
     * @todo Add a check in @nextcloud/vue 9 that this prop is not provided,
     * otherwise root element will inherit incorrect aria-hidden.
     */
    ariaHidden: {
      type: Boolean,
      default: null
    }
  }
};
var s = function() {
  var t = this, n = t._self._c;
  return n("li", { staticClass: "action", attrs: { role: t.isInSemanticMenu && "presentation" } }, [n("a", { staticClass: "action-link focusable", attrs: { download: t.download, href: t.href, "aria-label": t.ariaLabel, target: t.target, title: t.title, rel: "nofollow noreferrer noopener", role: t.isInSemanticMenu && "menuitem" }, on: { click: t.onClick } }, [t._t("icon", function() {
    return [n("span", { staticClass: "action-link__icon", class: [t.isIconUrl ? "action-link__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? "url(".concat(t.icon, ")") : null }, attrs: { "aria-hidden": "true" } })];
  }), t.name ? n("span", { staticClass: "action-link__longtext-wrapper" }, [n("strong", { staticClass: "action-link__name" }, [t._v(" " + t._s(t.name) + " ")]), n("br"), n("span", { staticClass: "action-link__longtext", domProps: { textContent: t._s(t.text) } })]) : t.isLongText ? n("span", { staticClass: "action-link__longtext", domProps: { textContent: t._s(t.text) } }) : n("span", { staticClass: "action-link__text" }, [t._v(t._s(t.text))]), t._e()], 2)]);
}, o = [], l = /* @__PURE__ */ i(
  r,
  s,
  o,
  !1,
  null,
  "c0bc0588",
  null,
  null
);
const u = l.exports;
export {
  u as default
};
